// Components
import DatepickerCompareTo from '@/components/base/Datepicker/DatepickerCompareTo';
import DatepickerBannerDataRetention from '@/components/composite/Datepicker/DatepickerBannerDataRetention';

// Types
import type { DatepickerCompareToProps } from '@/components/base/Datepicker/DatepickerCompareTo';

const DatepickerAnalyticsBottomSection = ({ compareTo, onChange }: DatepickerCompareToProps) => {
    return (
        <>
            <DatepickerBannerDataRetention />
            <DatepickerCompareTo
                compareTo={compareTo}
                onChange={(el) => {
                    onChange(el);
                }}
            />
        </>
    );
};

export default DatepickerAnalyticsBottomSection;
